import React from 'react'
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, Box } from '@chakra-ui/react'

export const ExternalContentModal = ({ isOpen, onClose, url, title }) => (
  <Modal isOpen={isOpen} onClose={onClose} size="full">
    <ModalOverlay />
    <ModalContent maxW="480px" h="90vh" m="auto">
      <ModalCloseButton top="12px" right="12px" zIndex={2} bg="white" borderRadius="full" _hover={{ bg: 'gray.100' }} />
      <ModalBody p={0}>
        <Box w="100%" h="100%">
          <iframe
            src={url}
            title={title}
            sandbox="allow-same-origin"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </Box>
      </ModalBody>
    </ModalContent>
  </Modal>
)
